import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Grid } from "@mui/material";
import MessageList from '../MessageList';
import Message from '../Message';
import MessageInput from '../MessageInput';
import styles from './Chat.module.css';

const Chat = (props) => {
  const { messages, userId, isLoading, inputProps, onSendMessage, warnAboutUnsavedChanges } = props;
  const { className, ...restInputProps } = inputProps;

  return (
    <>
      <Grid item>{isLoading && <MessageList messages={messages} userId={userId} />}</Grid>

      <div className={cn(className, styles.messageBox)}>
        <MessageInput
          onSubmit={onSendMessage}
          inputProps={{ ...restInputProps }}
          warnAboutUnsavedChanges={warnAboutUnsavedChanges}
        />
      </div>
    </>
  );
};

Chat.propTypes = {
  isLoading: Type.bool.isRequired,
  messages: Type.arrayOf(Type.shape(Message.propTypes.message)).isRequired,
  userId: Type.string.isRequired,
  inputProps: Type.shape({
    className: Type.string,
    maxLength: Type.number,
    placeholder: Type.string,
  }),
  onSendMessage: Type.func.isRequired,
  warnAboutUnsavedChanges: Type.bool,
};

Chat.defaultProps = {
  inputProps: null,
  warnAboutUnsavedChanges: true,
};

export default Chat;
